import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import TOSPage from "./pages/TOSPage";
import PasswordResetPage from "./pages/PasswordResetPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import DeleteAccountPage from "./pages/DeleteAccountPage";
import { useAuth } from "./lib/auth";
import ConnectExtensionPage from "./pages/ConnectExtensionPage";
import VerifyEmailPage from "./pages/VerifyEmailPage"; // adjust path



function IndexRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return <Navigate to={user ? "/connect" : "/auth/login"} replace />;
}


export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<IndexRedirect />} />

        <Route path="/auth/login" element={<LoginPage />} />
        <Route path="/auth/signup" element={<SignupPage />} />
        {/* The two halves of password reset, and they are separate routes on
            purpose. /auth/forgot SENDS the email and needs a captcha widget,
            because /recover is captcha-gated like every other auth entry point
            (7.2) - which is also why it cannot live in the extension, where the
            requirement originally put it. /auth/reset is where the emailed link
            LANDS; it needs no widget, because updateUser is gated on the
            recovery session rather than on a challenge. Keeping them apart
            keeps one Turnstile token to one endpoint. See 14.2, Phase 10.5. */}
        <Route path="/auth/forgot" element={<ForgotPasswordPage />} />
        <Route path="/auth/reset" element={<PasswordResetPage />} />
        <Route path="/connect" element={<ConnectExtensionPage />} />
        <Route path="/auth/verify" element={<VerifyEmailPage />} />

        {/* Deleting an account happens HERE, not in the extension. The password
            gate has to run on a page that can show a captcha widget - an MV3
            extension page cannot (deletionHandoff.ts) - and this page hands the
            token to the service worker, which owns the delete-then-wipe order. */}
        <Route path="/auth/delete-account" element={<DeleteAccountPage />} />

        {/* There is no /captcha route. The requirement specified a hosted page
            that ran reCAPTCHA, posted a token to /api/captcha/verify and had
            the extension poll /api/captcha/status - machinery for carrying a
            "captcha passed" signal from a tab back to whatever performs the
            signup. Signup is a plain form in THIS app, so there was nothing to
            carry it across, and a bot calling /auth/v1/signup directly would
            have skipped the page entirely. Turnstile through Supabase's
            built-in captcha verifies server-side inside GoTrue, which a direct
            caller cannot skip. See decisions 7.2 and the struck-through
            Captcha row in the requirements. */}
        <Route path="/tos" element={<TOSPage />} />

        <Route path="*" element={<h1 className="p-6">404 - Page Not Found</h1>} />
      </Routes>
    </BrowserRouter>
  );
}
